import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || '';

// Public "Set your password" page for a broker team invite.
// /team-invite/:token  → validates the invite, lets the teammate set a
// password, then logs them straight in (stores token + user, redirects).
export default function TeamInviteAccept() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/broker/invite-accept?token=${encodeURIComponent(token)}`);
        const d = await res.json().catch(() => ({}));
        if (!res.ok) setError(d.error || 'This invite is not valid.');
        else setInvite(d);
      } catch (_) {
        setError('Could not load this invite. Please check your connection.');
      }
      setLoading(false);
    })();
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) return setError('Password must be at least 8 characters.');
    if (pw !== pw2) return setError('Passwords do not match.');
    setBusy(true);
    try {
      const res = await fetch(`${API}/api/broker/invite-confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password: pw }),
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { setError(d.error || 'Could not set up your account.'); setBusy(false); return; }
      localStorage.setItem('token', d.token);
      if (d.user) localStorage.setItem('user', JSON.stringify(d.user));
      setDone(true);
      setTimeout(() => navigate('/dashboard'), 1200);
    } catch (_) {
      setError('Network error. Please try again.');
      setBusy(false);
    }
  };

  const card = {
    background: '#fff', borderRadius: 14, border: '1px solid #E2E8F0',
    boxShadow: '0 4px 24px rgba(0,0,0,0.06)', padding: 32, width: '100%', maxWidth: 420,
  };
  const wrap = {
    minHeight: '100vh', background: '#f8f9fa', display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: 16,
    fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
  };
  const inp = { width: '100%', padding: '11px 13px', border: '1px solid #cbd5e0', borderRadius: 8, fontSize: 15, boxSizing: 'border-box' };
  const lbl = { display: 'block', fontSize: 13, fontWeight: 600, color: '#4b5a6e', margin: '14px 0 5px' };

  const Brand = () => (
    <div style={{ marginBottom: 20 }}>
      <span style={{ fontSize: 22, fontWeight: 800, color: '#10b981' }}>Broker</span>
      <span style={{ fontSize: 22, fontWeight: 800, color: '#0e1b2c' }}>Connect</span>
    </div>
  );

  if (loading) return <div style={wrap}><div style={card}><Brand /><p style={{ color: '#718096' }}>Loading your invite…</p></div></div>;

  if (error && !invite) return (
    <div style={wrap}><div style={card}>
      <Brand />
      <h2 style={{ margin: '0 0 8px', fontSize: 20, color: '#0e1b2c' }}>Invite unavailable</h2>
      <p style={{ color: '#991b1b', fontSize: 14 }}>{error}</p>
      <button onClick={() => navigate('/login')} style={{ marginTop: 16, padding: '10px 16px', background: '#0e1b2c', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>Go to sign in</button>
    </div></div>
  );

  if (done) return (
    <div style={wrap}><div style={card}>
      <Brand />
      <h2 style={{ margin: '0 0 8px', fontSize: 20, color: '#065f46' }}>You're all set! 🎉</h2>
      <p style={{ color: '#718096', fontSize: 14 }}>Signing you in…</p>
    </div></div>
  );

  return (
    <div style={wrap}>
      <form style={card} onSubmit={submit}>
        <Brand />
        <h2 style={{ margin: '0 0 4px', fontSize: 20, color: '#0e1b2c' }}>Join {invite.company_name}</h2>
        <p style={{ margin: '0 0 8px', fontSize: 14, color: '#718096' }}>
          Hi {invite.name} — you've been invited as a <strong style={{ color: '#0e1b2c' }}>{invite.role}</strong>. Set a password to activate your account.
        </p>
        <p style={{ margin: '0 0 4px', fontSize: 13, color: '#a0aec0' }}>{invite.email}</p>

        {error && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '9px 12px', borderRadius: 6, fontSize: 13, margin: '12px 0' }}>{error}</div>}

        <label style={lbl}>Choose a password</label>
        <input type="password" value={pw} onChange={e => setPw(e.target.value)} style={inp} placeholder="At least 8 characters" autoComplete="new-password" />
        <label style={lbl}>Confirm password</label>
        <input type="password" value={pw2} onChange={e => setPw2(e.target.value)} style={inp} autoComplete="new-password" />

        <button type="submit" disabled={busy} style={{ width: '100%', marginTop: 20, padding: '12px', background: busy ? '#a7f3d0' : '#10b981', color: '#fff', border: 'none', borderRadius: 8, cursor: busy ? 'default' : 'pointer', fontWeight: 700, fontSize: 15 }}>
          {busy ? 'Setting up…' : 'Set password & sign in'}
        </button>
      </form>
    </div>
  );
}
